export default __webpack_public_path__ + "static/media/views_front.b8ac8516.svg";